import React from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  return (
    <nav className="bg-white border-b border-slate-200 sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <Link to="/" className="flex items-center gap-2">
            <span className="text-2xl font-bold text-slate-900 tracking-tight">
              ENVISU<span className="text-accent">.</span>
            </span>
          </Link>
          <div className="hidden md:flex space-x-8">
            <Link to="/" className="text-slate-700 hover:text-accent font-semibold transition-colors">Startseite</Link>
            <Link to="/ueber-uns" className="text-slate-700 hover:text-accent font-semibold transition-colors">Über uns</Link>
            <Link to="/karriere" className="text-slate-700 hover:text-accent font-semibold transition-colors">Karriere</Link>
            <Link to="/kontakt" className="text-slate-700 hover:text-accent font-semibold transition-colors">Kontakt</Link>
          </div>
          <div className="flex items-center">
            <Link to="/karriere" className="bg-slate-900 text-white px-4 py-2 rounded-md font-medium hover:bg-slate-800 transition-colors">
              Bewerben
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}